import {IHttpService, ILogService, IPromise} from "angular";

export class FirebaseService {
    private token: string;

    /* @ngInject */
    constructor(private $http: IHttpService,
                private $log: ILogService,
                private firebase) {
    }

    public getConfig(): IPromise<any> {
        return this.$http.get(`/api/firebase/config`)
            .then((resp) => {
                return resp.data;
            });
    }

    public createToken(): IPromise<any> {
        return this.$http.post(`/api/firebase/token`, {})
            .then((resp: any) => {
                this.token = resp.data;
                this.$log.debug("token", this.token);
                return resp.data;
            });
    }

    public getToken() {
        return this.token;
    }

    public signIn(): IPromise<any> {
        if (!this.token) {
            this.$log.error("No token.");
            return;
        }

        return this.firebase
            .auth()
            .signInWithCustomToken(this.token)
            .then((data) => {
                this.$log.info("Firebase sign in successfully.", data);
            })
            .catch((error) => {
                this.$log.error("Firebase auth failed", error);
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/firebase/firebase.service.ts